import React from 'react';

import get from 'lodash.get';

import { DocumentI } from 'interfaces/content-stack/modular-blocks/documents';

interface DocumentListItemProps {
  document: DocumentI;
}

function DocumentListItem({ document }: DocumentListItemProps) {
  const fileLink = get(document, 'document.url');
  const csFileLink = get(document, 'document.file.url');

  return (
    <li>
      <a href={fileLink ? fileLink : csFileLink} target='_blank' rel='noopener noreferrer'>
        {document.documentName ?? document.title}
      </a>
    </li>
  );
}

export default DocumentListItem;
